import amplitude from 'amplitude-js';

export const amplitudeLogEvent = (event, data) => {
  amplitude.getInstance().logEvent(event, { ...data, email: data.email });
};

// Multi-entry event names
export const MULTI_ENTRY_EVENTS = {
  ENTRY_ADDED: 'multi_entry_added',
  ENTRY_REMOVED: 'multi_entry_removed',
  TAB_SWITCHED: 'multi_entry_tab_switched',
  ANALYZE_COMPLETED: 'multi_entry_analyze_completed',
  WORKSPACE_SAVED: 'multi_entry_workspace_saved',
  REPORT_GENERATED: 'multi_entry_report_generated'
} as const;

/**
 * Log a multi-entry specific amplitude event with standard properties.
 */
export const logMultiEntryEvent = (eventName: string, data: Record<string, unknown> = {}) => {
  amplitudeLogEvent(eventName, {
    ...data,
    isMultiEntry: true,
    entryCount: data.entryCount ?? 1,
    timestamp: new Date().toISOString()
  });
};
